import React, { HTMLAttributes } from 'react';
import styled from 'styled-components/macro';
import { Center, Icon, IconName, Tooltip } from '@televet/kibble-ui';
import { DeviceSizes } from 'shared/enums/DeviceSizes';

interface IProps extends HTMLAttributes<HTMLElement> {
  iconName: IconName;
  title: string;
  isCurrentView: boolean;
  onClick?: () => void;
  noHoverChange?: boolean;
}

const PanelButton = ({ iconName, title, isCurrentView, onClick, ...rest }: IProps): JSX.Element => {
  return (
    <Tooltip label={title} placement="left" openDelay={750}>
      <StyledBox
        data-mixpanel-name={`Right panel ${title} icon`}
        data-testid={`right-panel-${title} icon`}
        onClick={onClick}
        background={isCurrentView ? 'background.primaryAlpha' : 'background.default'}
        transitionTimingFunction="ease-out"
        transitionDuration="normal"
        _hover={{
          background: 'background.primaryAlpha.hover',
        }}
        {...rest}
      >
        <Center data-mixpanel-name={`Right panel ${title} icon`} data-testid={`right-panel-${title} icon`}>
          <Icon name={iconName} size="lg" variant={isCurrentView ? 'success' : 'subtle'} />
        </Center>
      </StyledBox>
    </Tooltip>
  );
};

const StyledBox = styled(Center)`
  @media (${DeviceSizes.MobileMaxWidth}) {
    & svg {
      width: 32px;
      height: 32px;
      padding: 0px !important;
    }
    width: 100%;
    height: 64px;
  }

  cursor: pointer;
  width: 56px;
  height: 56px;
`;

export default PanelButton;
